import React from "react";
import {Container} from "semantic-ui-react";
import FleetTypesList from "../../../components/torres/fleet-type-components/fleet-types-list";

const FleetTypePage = () => {

    return (
        <Container style={{padding: "20px"}}>
            <FleetTypesList/>
        </Container>
    );
};

export default FleetTypePage;
